import { CellFormatter } from '@tableau/data-catalog-client-components/lib/src/components/sharedDisplayGrid/types/SharedDisplayGridTypes';
import { DataGrid } from '@tableau/widgets-datagrid';

export function replaceColumnCellFormattersForDatabasesAndTables(mappedCellFormatters: Record<string, CellFormatter>, columns: DataGrid.Column[]) {
    columns.forEach(column => {
      if (mappedCellFormatters[column.name]) {
        column.cellFormatter = mappedCellFormatters[column.name].cellFormatter;
      }
    });
  }